import angular from 'angular';

module.exports = angular.module('common.services.third-party-library-integrations', [
  require('angular-ui-router'),
])
.factory('optimizely', function() {
  window.optimizely = window.optimizely || [];
  return window.optimizely;
})
.run(function($rootScope, $document, $window, optimizely) {
  let remove;
  $rootScope.$on('$stateChangeSuccess', function(e, to) {
    // Remove any previous `$viewContentLoaded` event listeners on $rootScope on the next state
    // change so that it won't grow indefinitely. We don't want to remove it right after the first
    // $viewContentLoaded event is fired because multiple get fired on each state change and we
    // need to catch the last one to ensure Optimizely has all the content to modify.
    if (remove) {
      remove();
    }

    remove = $rootScope.$on('$viewContentLoaded', function() {
      optimizely.push(['activate']);
    });

    // Instead of initializing Branch on page load and relying solely on it recognizing URL changes
    // to show or hide the banner, we determine ourselves whether to remove or initialize it on
    // every `$stateChangeSuccess`.
    const BRANCH_CLIENT_SIDE_KEY = 'key_live_nhwpsaI8sYEkp1XQUKyyEafdDBesEuk2';
    let branchBanner = $document[0].getElementById('branch-banner-iframe');

    // need to disable for homes.show.prelisting,
    // but it needs to skip homes.show as well, which is prelisting's parent state
    // page doesn't render during the transition to homes.show.prelisting,
    // so to.name != 'homes.show.prelisting' alone doesn't prevent branchBanner showing up,
    // and we should proactively prevent adding the iframe in homes.show
    if (to &&
      to.name.match(/^homes\./) &&
      to.name != 'homes.show' &&
      to.name != 'homes.show.prelisting') {
      if ($window.branch && !branchBanner) {
        $window.branch.init(BRANCH_CLIENT_SIDE_KEY);
      }
    } else if (branchBanner) {
      $document[0].body.removeChild(branchBanner);
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/third-party-library-integrations.js
 **/